module.exports = __webpack_public_path__ + "img/games-7.acc4b558.webp";